/* eslint-disable @typescript-eslint/no-use-before-define */
import { PollingTaskStatus } from './types';

type Dispatch = (action: any) => any;

const intervals = new Map<string, ReturnType<typeof setInterval>>();

const runTick = async (
    id: string,
    fetchStatus: () => Promise<PollingTaskStatus>,
    dispatch: Dispatch,
): Promise<void> => {
    try {
        const result = await fetchStatus();
        dispatch({ type: 'pollingStatus/updated', payload: { id, result } });
        if (result.status !== 'loading') {
            stop(id);
        }
    } catch (e: any) {
        dispatch({
            type: 'pollingStatus/updated',
            payload: {
                id,
                result: {
                    status: 'error',
                    errors: [e?.message ?? 'Erro desconhecido'],
                } as PollingTaskStatus,
            },
        });
        stop(id);
    }
};

export const start = (
    id: string,
    fetchStatus: () => Promise<PollingTaskStatus>,
    intervalMs: number,
    dispatch: Dispatch,
): void => {
    stop(id);
    runTick(id, fetchStatus, dispatch);
    const handle = setInterval(() => runTick(id, fetchStatus, dispatch), intervalMs);
    intervals.set(id, handle);
};

export const stop = (id: string): void => {
    const handle = intervals.get(id);
    if (handle !== undefined) {
        clearInterval(handle);
        intervals.delete(id);
    }
};

export const stopAll = (): void => {
    intervals.forEach((handle) => clearInterval(handle));
    intervals.clear();
};
